export const encodeBase64Url = (str: string) => {
  return btoa(str).replace(/=+$/, '')
}
